import { combineReducers, configureStore } from '@reduxjs/toolkit';
import cancelledOrdersSlice from './cancelledOdersSlice';
import currentOrderReducer from './currentOrderSlice';
import errorSlice from './errorSlice';
import navigationReducer from './navigationSlice';
import newOrderReducer from './newOrderSlice';
import userdataReducer from './userdataSlice';

const rootReducer = combineReducers({
  navigationdata: navigationReducer,
  userdata: userdataReducer,
  newOrder: newOrderReducer,
  currentOrder: currentOrderReducer,
  errorState: errorSlice,
  cancelledOrders: cancelledOrdersSlice,
});

// One store per request on the server and one per browser session, so state never leaks between users
export const makeStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
    devTools: process.env.NEXT_PUBLIC_ENV !== 'production',
  });

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<typeof rootReducer>;
